module.exports = "/assets/data/1028a9b407dc2b80dee04ff312c6501d-BS4.data.json";